import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { SearchTemplateComponent } from "./search-template.component";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap";
import { PaginationARModule } from "../../pagination/pagination-ar.module";

@NgModule({
  imports: [
    CommonModule,
    PaginationARModule,
    TableModule,
    FormsModule,
    ModalModule.forRoot()
  ],
  declarations: [SearchTemplateComponent],
  exports: [SearchTemplateComponent]
})
export class SearchTemplateModule {}
